import React, { useState } from 'react';
import { Camera, Upload, X } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import axios from 'axios';
import { authHeaders, API_ENDPOINTS } from './api';

export const ImageUploader = ({ value, onChange, label = "Image", compact = false }) => {
  const [uploading, setUploading] = useState(false);
  const [drag, setDrag] = useState(false);

  const doUpload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await axios.post(API_ENDPOINTS.adminUpload, fd, { headers: authHeaders() });
      onChange(res.data.url);
      toast.success('Image telechargee');
    } catch (err) {
      console.error('Upload failed:', err);
      toast.error(err.response?.data?.detail || "Erreur upload");
    } finally {
      setUploading(false);
    }
  };

  if (compact) {
    return (
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative group w-14 h-14 rounded-xl overflow-hidden border border-gray-200 flex-shrink-0">
            <img src={value} alt="" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
              <label className="cursor-pointer">
                <Camera className="w-4 h-4 text-white" />
                <input type="file" accept="image/*" onChange={e => doUpload(e.target.files[0])} className="hidden" />
              </label>
            </div>
          </div>
        ) : (
          <label
            className={`w-14 h-14 rounded-xl border-2 border-dashed flex items-center justify-center cursor-pointer flex-shrink-0 transition-colors ${drag ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-400'}`}
            onDragOver={e => { e.preventDefault(); setDrag(true); }}
            onDragLeave={() => setDrag(false)}
            onDrop={e => { e.preventDefault(); setDrag(false); doUpload(e.dataTransfer.files[0]); }}
          >
            {uploading ? <div className="animate-spin h-4 w-4 border-2 border-blue-500 border-t-transparent rounded-full" /> : <Upload className="w-4 h-4 text-gray-400" />}
            <input type="file" accept="image/*" onChange={e => doUpload(e.target.files[0])} className="hidden" />
          </label>
        )}
        <Input value={value} onChange={e => onChange(e.target.value)} placeholder="URL de l'image..." className="h-9 text-sm flex-1" />
        {value && <button type="button" onClick={() => onChange('')} className="text-gray-400 hover:text-red-500"><X className="w-4 h-4" /></button>}
      </div>
    );
  }

  return (
    <div>
      <Label className="text-xs font-medium text-gray-500 mb-2 block">{label}</Label>
      <div className="flex gap-3 items-start">
        {value ? (
          <div className="relative group w-28 h-20 rounded-xl overflow-hidden border border-gray-200 flex-shrink-0">
            <img src={value} alt="" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-1.5">
              <label className="cursor-pointer p-1.5 bg-white/90 rounded-full">
                <Camera className="w-3.5 h-3.5 text-gray-700" />
                <input type="file" accept="image/*,video/mp4,application/pdf" onChange={e => doUpload(e.target.files[0])} className="hidden" />
              </label>
              <button type="button" onClick={() => onChange('')} className="p-1.5 bg-white/90 rounded-full"><X className="w-3.5 h-3.5 text-red-500" /></button>
            </div>
            {uploading && <div className="absolute inset-0 bg-white/80 flex items-center justify-center"><div className="animate-spin h-5 w-5 border-2 border-blue-500 border-t-transparent rounded-full" /></div>}
          </div>
        ) : (
          <div
            className={`w-28 h-20 rounded-xl border-2 border-dashed flex flex-col items-center justify-center cursor-pointer flex-shrink-0 transition-colors ${drag ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-400'}`}
            onDragOver={e => { e.preventDefault(); setDrag(true); }}
            onDragLeave={() => setDrag(false)}
            onDrop={e => { e.preventDefault(); setDrag(false); doUpload(e.dataTransfer.files[0]); }}
            onClick={() => document.getElementById(`up-${label}`).click()}
          >
            {uploading ? (
              <div className="animate-spin h-5 w-5 border-2 border-blue-500 border-t-transparent rounded-full" />
            ) : (
              <>
                <Upload className="w-4 h-4 text-gray-400 mb-0.5" />
                <span className="text-[9px] text-gray-400">Glisser ici</span>
              </>
            )}
            <input id={`up-${label}`} type="file" accept="image/*,video/mp4,application/pdf" onChange={e => doUpload(e.target.files[0])} className="hidden" />
          </div>
        )}
        <div className="flex-1">
          <Input value={value} onChange={e => onChange(e.target.value)} placeholder="URL ou glisser une image..." className="h-9 text-sm" />
        </div>
      </div>
    </div>
  );
};
